import {isNotNil} from 'ramda';

import {metadaApi} from '@dms/api/base';

import {
  BaseServiceOrderVariant,
  GetServiceOrderVariantsRequest,
  GetServiceOrderVariantsResponse,
} from './types';

export const metadaWarehouseServiceOrderVariantsApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getServiceOrderVariants: build.query<BaseServiceOrderVariant[], GetServiceOrderVariantsRequest>(
      {
        query: () => ({
          url: `service/v2/service-order-variant`,
          method: 'GET',
        }),
        providesTags: ['serviceOrderVariants'],
        transformResponse: (response: GetServiceOrderVariantsResponse) =>
          response?.filter(isNotNil) ?? [],
      }
    ),
  }),
});

export const {useGetServiceOrderVariantsQuery} = metadaWarehouseServiceOrderVariantsApi;
